import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { getTarget } from '../services/api';

const TargetDetails = () => {
  const { id } = useParams();
  const [target, setTarget] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    loadTarget();
  }, [id]);

  const loadTarget = async () => {
    try {
      const response = await getTarget(id);
      setTarget(response.data);
    } catch (err) {
      setError('Errore nel caricamento');
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('it-IT');
  };

  const getStatusText = (status) => {
    switch (status) {
      case 'open': return 'Aperta';
      case 'confirmed': return 'Confermata';
      case 'completed': return 'Completata';
      case 'cancelled': return 'Annullata';
      default: return status;
    }
  };

  if (loading) return <div className="loading">Caricamento...</div>;
  if (error) return <div className="error-message">{error}</div>;
  if (!target) return <div className="error-message">Persona non trovata</div>;

  return (
    <div className="page-container">
      <div className="page-header">
        <Link to="/targets" className="back-link">← Torna alla lista</Link>
      </div>

      <div className="target-header">
        <h1>{target.name}</h1>
        {target.notes && <p className="target-notes">{target.notes}</p>}
      </div>

      <Link to={`/proposals/new?target=${id}`} className="btn btn-primary">
        Proponi una visita
      </Link>

      <section className="section">
        <h2>Storico visite</h2>
        {target.visits.length === 0 ? (
          <p className="empty-state">Nessuna visita registrata</p>
        ) : (
          <ul className="visit-list">
            {target.visits.map((visit, index) => (
              <li key={index} className="visit-item">
                {formatDate(visit.date)}
              </li>
            ))}
          </ul>
        )}
      </section>

      <section className="section">
        <h2>Proposte</h2>
        {target.proposals.filter(p => p.status !== 'completed').length === 0 ? (
          <p className="empty-state">Nessuna proposta attiva</p>
        ) : (
          <div className="proposal-list">
            {target.proposals.filter(p => p.status !== 'completed').map((proposal) => (
              <div key={proposal._id} className={`proposal-card proposal-${proposal.status}`}>
                <div className="proposal-header">
                  <span className={`badge badge-${proposal.status}`}>
                    {getStatusText(proposal.status)}
                  </span>
                  <span className="proposal-date">
                    {formatDate(proposal.createdAt)}
                  </span>
                </div>
                <div className="proposal-info">
                  <p><strong>Organizzatore:</strong> {proposal.organizerId.username}</p>
                  {proposal.companionId && (
                    <p><strong>Accompagnatore:</strong> {proposal.companionId.username}</p>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </section>
    </div>
  );
};

export default TargetDetails;
